import React, { useState } from 'react';
import './ServicesEditor.css';

interface ServicesEditorProps {
  selectedSection: string | null;
  editMode: boolean;
  editableContent: { [key: string]: string };
  handleSectionClick: (section: string) => void;
  handleEditChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSaveChanges: () => void;
  handleCancelEdit: () => void;
}

const ServicesEditor: React.FC<ServicesEditorProps> = ({
  selectedSection,
  editMode,
  editableContent,
  handleSectionClick,
  handleEditChange,
  handleSaveChanges,
  handleCancelEdit,
}) => {
  const [activeSection, setActiveSection] = useState<string | null>(null);

  const toggleSection = (section: string) => {
    setActiveSection(activeSection === section ? null : section);
  };

  return (
    <div className="services-editor-accordion">
      <div className="accordion-item">
        <h3 onClick={() => toggleSection('services')}>Servicios</h3>
        {activeSection === 'services' && (
          <div className="accordion-content">
            {['titulo-1', 'subtitulo-1', 'titulo-2', 'subtitulo-2', 'titulo-3', 'subtitulo-3', 'titulo-4', 'subtitulo-4'].map((section, index) => (
              <div key={section} className="service-item">
                <button
                  onClick={() => handleSectionClick(section)}
                  className={selectedSection === section ? 'selected-menu-item' : ''}
                >
                  {index % 2 === 0 ? `Editar Título ${Math.floor(index / 2) + 1}` : `Editar Subtítulo ${Math.floor(index / 2) + 1}`}
                </button>
                {editMode && selectedSection === section && (
                  <div className="editor-panel">
                    <h4>Editar {section}</h4>
                    <textarea
                      name={section}
                      value={editableContent[section] || ''}
                      onChange={handleEditChange}
                    />
                    <button onClick={handleSaveChanges}>Guardar Cambios</button>
                    <button onClick={handleCancelEdit}>Cancelar</button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ServicesEditor;
